import { render, staticRenderFns } from "./AddNewSkillQulificationCategoryPopUp.vue?vue&type=template&id=b5ec8d56&scoped=true&"
import script from "./AddNewSkillQulificationCategoryPopUp.vue?vue&type=script&lang=js&"
export * from "./AddNewSkillQulificationCategoryPopUp.vue?vue&type=script&lang=js&"
import style0 from "./AddNewSkillQulificationCategoryPopUp.vue?vue&type=style&index=0&id=b5ec8d56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ec8d56",
  null
  
)

export default component.exports